const env = process.env.REACT_APP_ENV ?? "dev";

interface URLs {
  securityRootUrl: string;
}

const configs: Record<string, URLs> = {
  ["tjt.dev"]: {
    securityRootUrl: "https://msm333d7rb.execute-api.ap-southeast-2.amazonaws.com/security"
  },
  ["dev"]: {
    securityRootUrl: "https://dev.nx.nutrien.com.au/security"
  },
  ["dev-blue"]: {
    securityRootUrl: "https://dev-blue.nx.nutrien.com.au/security"
  },
  ["dev-green"]: {
    securityRootUrl: "https://dev-green.nx.nutrien.com.au/security"
  },
  ["staging"]: {
    securityRootUrl: "https://stage.nx.nutrien.com.au/security"
  },
  ["uat"]: {
    securityRootUrl: "https://uat.nx.nutrien.com.au/security"
  },
  ["uat-blue"]: {
    securityRootUrl: "https://uat-blue.nx.nutrien.com.au/security"
  },
  ["uat-green"]: {
    securityRootUrl: "https://uat-green.nx.nutrien.com.au/security"
  },
  ["pp"]: {
    securityRootUrl: "https://pp.nx.nutrien.com.au/security"
  },
  ["train"]: {
    securityRootUrl: "https://training.nx.nutrien.com.au/security"
  },
  ["prod"]: {
    securityRootUrl: "https://nx.nutrien.com.au/security"
  },
  ["prod-blue"]: {
    securityRootUrl: "https://prod-blue.nx.nutrien.com.au/security"
  },
  ["prod-green"]: {
    securityRootUrl: "https://prod-green.nx.nutrien.com.au/security"
  }
};

const apiConfig = configs[env] ?? configs.dev;

export { apiConfig };
